/**
 * ConfigClone
 */

import Config from './Config';
import Util from './Util';
import Site from './Site';

let INSTANCE: GameInfo = null;

const LOCALE: any = {
  'en-US': 'SEA',
  'zh-TW': 'TW',
  'ko-KR': 'KR'
};

class GameInfo {
  private mobileSites: string[];

  private site: string;

  private isLogin: boolean;

  private locale: string;

  private group: string;

  private favTeamId: string;

  private favTeamName: string;

  private gameAccountName: string;

  private gameAccountServerId: string;

  private win: any;

  private path: string;

  private isMyArticle: boolean = false;

  constructor() {
    if (!INSTANCE) {
      this.win = window as any;
      this.path = this.win._path;

      const USER_DATA = this.win.userData;

      this.isMyArticle = this.win.isMine || false;
      this.mobileSites = ['lineagem', 'h2', 'l2m'];
      this.site = (USER_DATA && USER_DATA.site) || '';
      this.isLogin = (USER_DATA && USER_DATA.isLogin) || false;
      this.locale = LOCALE[USER_DATA && USER_DATA.locale] || 'KR';
      this.group = `${this.site}${this.locale}`;
      this.favTeamId = USER_DATA && USER_DATA.gameAccount && USER_DATA.gameAccount.favTeamId;
      this.favTeamName = USER_DATA && USER_DATA.gameAccount && USER_DATA.gameAccount.favTeamName;
      this.gameAccountName = USER_DATA && USER_DATA.gameAccount && USER_DATA.gameAccount.name;
      this.gameAccountServerId = USER_DATA && USER_DATA.gameAccount && USER_DATA.gameAccount.serverId;

      INSTANCE = this;
    }

    return INSTANCE;
  }

  public isMine() {
    return !!this.isMyArticle;
  }

  public isLogined() {
    return this.isLogin;
  }

  public getCharacterInfoAPIUrl(charName: string, serverId: string, userUid: string, charId: string = '', gameCode: number = 0) {
    if (this.getSite() === 'aion') {
      return Config.profileCharacterByCharacterId(serverId, charId);
    }

    if (this.getSite() === 'bns') {
      return Config.profileCharacterByCharacterId(serverId, charId, gameCode);
    }

    if (Config.isProfileWithCharName) {
      return Config.profileCharacterByCharacterName(charName, serverId, charId);
    } else {
      return Config.profileCharacter(userUid, serverId, Config.isProfileWithCharId ? charId : '');
    }
  }

  public thumbnailUrl(thumb = '') {
    let newThumb = thumb;
    if (newThumb && this.getSite() === 'lineage') {
      newThumb = newThumb.replace('/download_thumbnail/', '/download_preset/small/');
    }

    return newThumb;
  }

  public isMobileSite() {
    return this.mobileSites.indexOf(this.site) !== -1 ? true : false;
  }

  public getMobileSites() {
    return this.mobileSites;
  }

  public getSite() {
    return this.site;
  }

  public isEqualGameUser(gameCharName: string = '', gameServerId: string = '') {
    if (!gameCharName || !gameServerId) {
      return false;
    }

    return this.gameAccountName && this.gameAccountName === gameCharName && this.gameAccountServerId && this.gameAccountServerId.toString() === gameServerId.toString()
      ? true
      : false;
  }

  public isEqualLoginName(name: string = '', gameServerId: string = '') {
    if (!name || !gameServerId) {
      return false;
    }

    return this.gameAccountName && this.gameAccountName === name && this.gameAccountServerId && this.gameAccountServerId.toString() === gameServerId.toString() ? true : false;
  }

  public getGameName() {
    return this.gameAccountName;
  }

  public getGameServerId() {
    return this.gameAccountServerId;
  }

  public getFavTeamId() {
    return this.favTeamId;
  }

  public getFavTeamName() {
    return this.favTeamName;
  }

  public net() {
    if (/^dev\./.test(location.hostname)) {
      return 'live';
    } else if (/^(rc\.|rc-)/.test(location.hostname)) {
      return `rc`;
    } else if (/^opdev/.test(location.hostname)) {
      return `opdev`;
    }

    return 'live';
  }

  // public replaceUrl(url:string, data:any) {
  //   if( url.indexOf('{serverType}') !== -1 && data.serverType ) {
  //     url = url.replace('{serverType}', data.serverType);
  //   }
  //
  //   if( url.indexOf('{accountId}') !== -1 && data.serverType ) {
  //     url = url.replace('{accountId}', data.accountId );
  //   }
  //
  //   if( url.indexOf('{serverId}') !== -1 && data.serverType ) {
  //     url = url.replace('{serverId}', data.serverId );
  //   }
  //
  //   if( url.indexOf('{charId}') !== -1 && data.serverType ) && data.serverType {
  //     url = url.replace('{charId}', data.charId );
  //   }
  //
  //   if( url.indexOf('{characterName}') !== -1 && data.serverType ) {
  //     url = url.replace('{characterName}', data.characterName );
  //   }
  //
  //   if( url.indexOf('{guid}') !== -1 && data.guid ) {
  //     url = url.replace('{guid}', data.guid );
  //   }
  //
  //   if( url.indexOf('{serverId}') !== -1 && data.serverId ) {
  //     url = url.replace('{serverId}', data.serverId );
  //   }
  //   return url;
  // }

  /* character
   * h2 - /{gameUserUid}/{serverId}/{characterId}
   * lineageM - /{serverId}/{characterId}
   * aion - /characters/server/{serverId}/id/{charId}/home
   * bns - /world/character/{serverType}}/{serverId}/{characterName}/
   * lineage2 - /character/{serverId}/{charId}/myboard
   */
  // gameAccount
  // public gameUserProfile(gameAccountId: string, guid: string, myGuid: string, characterName: string, serverId: string, charId: string = '', gameCode: number = 0) {
  //   const data = {
  //     gameAccountId,
  //     guid,
  //     myGuid,
  //     characterName,
  //     serverId,
  //     charId,
  //     gameCode,
  //   };
  //
  //   let url =
  //       (guid && guid === myGuid) || this.isEqualGameUser(characterName, serverId)
  //           ? Config.myCharacterUrl
  //           : Config.characterUrl;
  //
  //   const _charId = charId && Config.isProfileWithCharId ? `${charId}/` : ``;
  //   let _accountId = !_charId && gameAccountId ? `${gameAccountId}/` : ``;
  //
  //   if (Config.isProfileWithGameAccountId) {
  //     data.accountId = `${gameAccountId}/`;
  //   }
  //
  //   const _serverType = ( this.getSite() === 'bns' && gameCode === Config.bnsServerType.LIVE ) ? `LIVE` : `FRONTIER`;
  //
  //   return this.replaceUrl(url, data);
  // }
  //
  // // ncAccount
  // public userProfile(guid: string, myGuid: string, characterName: string = '', serverId: string = '') {
  //   let url = ( (guid && guid === myGuid) || this.isEqualGameUser(characterName, serverId) ) ?
  //       Config.myProfileUrl : Config.profileUrl;
  //
  //   const data = {
  //     guid,
  //     myGuid,
  //     characterName,
  //     serverId
  //   };
  //
  //   return url = this.replaceUrl(url, data);
  // }
  public gameUserProfile(gameAccountId: string, guid: string, myGuid: string, characterName: string, serverId: string, charId: string = '', gameCode: number = 0) {
    const _charId = charId && Config.isProfileWithCharId ? `${charId}/` : ``;
    let _accountId = !_charId && gameAccountId ? `${gameAccountId}/` : ``;
    let url = '';

    if (Config.isProfileWithGameAccountId) {
      _accountId = `${gameAccountId}/`;
    }

    if (this.getSite() === 'aion') {
      // return `${ Util.setDefaultPath( this.path ) }characters/server/${ serverId }/id/${ charId }/home`;
      url = `/characters/server/${serverId}/id/${charId}/home`;
    } else if (this.getSite() === 'lineage2') {
      url = `/character/${serverId}/${charId}/myboard`;
    } else if (this.getSite() === 'bns') {
      const _serverType = gameCode === Config.bnsServerType.LIVE ? `LIVE` : `FRONTIER`;
      url = `/world/character/${_serverType}/${serverId}/${characterName}/`;
    } else {
      url =
        (guid && guid === myGuid) || this.isEqualGameUser(characterName, serverId)
          ? `${Util.setDefaultPath(this.path)}my/profile/character`
          : `${Util.setDefaultPath(this.path)}profile/character/${_accountId}${serverId}/${_charId}board/list`;
    }

    return url;
  }

  // np
  public userProfile(guid: string, myGuid: string, characterName: string = '', serverId: string = '') {
    let url;

    if (this.getSite() === 'aion' || this.getSite() === 'bns') {
      return ``;
    }

    if (this.getSite() === 'tricksterm') {
      url = `/profile/user/${guid}/board/list`;
    } else if (this.getSite() === 'h3') {
      url =
        (guid && guid === myGuid) || this.isEqualGameUser(characterName, serverId)
          ? `${Util.setDefaultPath(this.path)}my/profile/board/list`
          : `${Util.setDefaultPath(this.path)}profile/user/${guid}/board/list`;
    } else {
      url =
        (guid && guid === myGuid) || this.isEqualGameUser(characterName, serverId)
          ? `${Util.setDefaultPath(this.path)}my/profile/character`
          : `${Util.setDefaultPath(this.path)}profile/user/${guid}/board/list`;
    }

    return url;
  }
}

export default new GameInfo();
